import app from '../../forum/app';
import Page from '../../common/components/Page';
import NotificationList from './NotificationList';
import extractText from '../../common/utils/extractText';

/**
 * The `NotificationsPage` component shows the notifications list. It is only
 * used on mobile devices where the notifications dropdown is within the drawer.
 */
export default class NotificationsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.history.push('notifications', extractText(app.translator.trans('core.forum.notifications.title')));
    app.notifications.load();
    this.bodyClass = 'App--notifications';
  }
  view() {
    return m("div", {
      className: "NotificationsPage"
    }, m(NotificationList, {
      state: app.notifications
    }));
  }
}
flarum.reg.add('core', 'forum/components/NotificationsPage', NotificationsPage);